import script from "./KCounter.vue?vue&type=script&setup=true&lang=ts"
export * from "./KCounter.vue?vue&type=script&setup=true&lang=ts"

import "./KCounter.vue?vue&type=style&index=0&id=04e50776&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04e50776"]])

export default __exports__